import 'lazysizes';

import '../css/reset.css';
import '../css/common.css';
import '../css/test-medicine.css';

import ClipBoard from 'clipboard';
import { getClientID, OLD_API_URL, requestPOST } from './common-es6';
import { trostBridgeConfig } from '../../components/utils/trostBridgeConfig';
import { firebaseEventKey } from '../../components/utils/firebaseEventKey';

const snsShareKakao = document.getElementsByClassName('sns-kakao')[0];
const snsShareFacebook = document.getElementsByClassName('sns-facebook')[0];
const snsShareTwitter = document.getElementsByClassName('sns-twitter')[0];
const snsShareLink = document.getElementsByClassName('sns-link')[0];

const shareMainLink = `${location.origin}/service/test/medicine/`;

const sendLink = () => {
  Kakao.Link.sendDefault({
    objectType: 'feed',
    content: {
      title: '지금 나의 심리상태와 성격이 궁금하다면?',
      description: '전문적인 자기분석 검사로 나의 진짜 심리상태와 성격 알아보기!',
      imageUrl: 'https://assets.trost.co.kr/images/service/tests/share_sns_kakao.png',
      link: {
        mobileWebUrl: shareMainLink,
        webUrl: shareMainLink
      },
      imageWidth: 800,
      imageHeight: 800
    },
    social: {
      likeCount: 286,
      commentCount: 45,
      sharedCount: 845
    },
    buttons: [
      {
        title: '지금 자기분석 테스트 시작',
        link: {
          mobileWebUrl: shareMainLink,
          webUrl: shareMainLink
        }
      }
    ]
  });
};

// 평가 질문
const realQuestions = [
  ['지금 내가 복용중인 약들의 이름을 알고 있다.', [0, 1, 2, 3]],
  ['지금 내가 복용중인 약들 각각의 효과와 효능을 알고 있다.', [0, 1, 2, 3]],
  ['지금 내가 복용중인 약들의 부작용을 알고 있다.', [0, 1, 2, 3]],
  ['나는 항정신성, 혹은 마약류 의약품을 복용중이다.', [3, 2, 1, 0]],
  ['나는 2곳 이상의 병원에서 처방한 약을 함께 복용중이다.', [3, 2, 1, 0]],
  ['약을 복용한 후로 기억력 감퇴, 성욕감소 등 정신적인 증상이 발생했다.', [3, 2, 1, 0]],
  ['약을 정해진 용법대로 정해진 시간에 복용중이다.', [0, 1, 2, 3]],
  ['약을 끊고 싶지만 끊을 수가 없다.', [3, 2, 1, 0]],
  ['나는 심리치료 등의 방법으로 약을 천천히 끊어갈 의향이 있다.', [0, 1, 2, 3]],
  ['약에 대한 의존도가 점점 증가하는 것 같다.', [3, 2, 1, 0]],
  ['나는 약을 1년 이상 장기 복용 중이다.', [3, 2, 1, 0]],
  ['내가 복용중인 약물의 개수나 강도가 처음보다 증가하였다.', [3, 2, 1, 0]],
  ['약 처방을 위해 정신과 방문시 30분 이상 상담을 받고 있다.', [0, 1, 2, 3]],
  ['정신과 상담 후 심리가 개선된 느낌을 받고 있다.', [0, 1, 2, 3]]
];

let testPoint = 0;
let clickedAnswerData = 0;

const initProgressBar = (clickedCount = 0, totalCount = 0) => {
  if ((!clickedCount) || (!totalCount)) {
    document.getElementsByClassName('program-progress-bar-percent')[0].innerHTML = '0%';
    document.getElementsByClassName('program-progress-bar-fill')[0].style.background = '';
    document.getElementsByClassName('program-progress-bar-fill')[0].style.width = 0;

    return false;
  }

  const clickedCountPercent = Math.round((clickedCount / totalCount) * 100);
  let progressBarBGColor = '';

  if (clickedCountPercent < 31) {
    progressBarBGColor = 'e06950';
  } else if (clickedCountPercent < 61) {
    progressBarBGColor = 'ffb74f';
  } else {
    progressBarBGColor = '82c783';
  }

  document.getElementsByClassName('program-progress-bar-percent')[0].innerHTML = `${clickedCountPercent}%`;
  document.getElementsByClassName('program-progress-bar-fill')[0].style.backgroundColor = `#${progressBarBGColor}`;
  document.getElementsByClassName('program-progress-bar-fill')[0].style.width = `${clickedCountPercent}%`;

  if (clickedCountPercent >= 100) {
    document.getElementsByClassName('program-progress-bar-fill')[0].style.borderRadius = '10px';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // SNS 공유
  if (snsShareKakao) {
    snsShareKakao.addEventListener('click', () => {
      sendLink();
    });
  }

  if (snsShareFacebook) {
    snsShareFacebook.addEventListener('click', () => {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareMainLink}`);
    });
  }

  if (snsShareTwitter) {
    snsShareTwitter.addEventListener('click', () => {
      window.open(`https://twitter.com/intent/tweet?text=자기분석 심리/성격검사 테스트&url=${shareMainLink}`);
    });
  }

  if (snsShareLink) {
    snsShareLink.addEventListener('click', () => {
      snsShareLink.setAttribute('data-clipboard-text', shareMainLink);

      const clipboard = new ClipBoard('.sns-link');

      clipboard.on('success', (e) => {
        alert('URL이 복사되었어요. 원하는 곳에 붙여넣기 해주세요.');
        e.clearSelection();
      });
    });
  }

  let programQuestionsEl = '';

  for (let i = 0; i < realQuestions.length; i++) {
    programQuestionsEl = `${programQuestionsEl}<h4>Q. ${realQuestions[i][0]}</h4>`
      + '<table data-role="table" class="program-medicine-answer-table">'
      + '<tr>'
      + `<td data-value="${realQuestions[i][1][0]}">1</td>`
      + '<td class="not_choice"></td>'
      + `<td data-value="${realQuestions[i][1][1]}">2</td>`
      + '<td class="not_choice"></td>'
      + `<td data-value="${realQuestions[i][1][2]}">3</td>`
      + '<td class="not_choice"></td>'
      + `<td data-value="${realQuestions[i][1][3]}">4</td>`
      + '</tr>'
      + '</table>'
      + '<div class="question-point-guide">'
      + '<span class="low">전혀<br class="display-only-mobile"/> 아니다</span>'
      + '<span class="high">매우<br class="display-only-mobile"/> 그렇다</span>'
      + '</div>'
      + '<hr/>';
  }

  document.getElementById('program-questions-list').innerHTML = `${programQuestionsEl}`;

  // 프로그램 Clicked 이벤트 설정
  const questionEl = document.getElementsByClassName('program-medicine-answer-table');
  const questionLength = document.getElementsByClassName('program-medicine-answer-table').length;

  for (let i = 0; i < questionLength; i += 1) {
    const questionAnswerEl = questionEl[i].getElementsByTagName('td');
    const questionAnswerLength = questionEl[i].getElementsByTagName('td').length;

    for (let j = 0; j < questionAnswerLength; j += 1) {
      if (!questionAnswerEl[j].classList.contains('not_choice')) {
        questionAnswerEl[j].addEventListener('click', () => {
          for (let k = 0; k < questionAnswerLength; k += 1) {
            if (questionAnswerEl[k].classList.contains('clicked')) {
              clickedAnswerData -= 1;
            }

            questionAnswerEl[k].classList.remove('clicked');
          }

          if (!questionAnswerEl[j].classList.contains('clicked')) {
            questionAnswerEl[j].classList.add('clicked');
            clickedAnswerData += 1;
          }

          initProgressBar(clickedAnswerData, realQuestions.length);

          if (document.getElementsByClassName('program-questions-point')[0].getElementsByClassName('clicked').length === realQuestions.length) {
            document.getElementById('program-medicine-finish').classList.add('actived');
          }
        });
      }
    }
  }

  // '결과보기' 버튼 선택 시
  document.getElementById('program-medicine-finish').addEventListener('click', () => {
    if (document.getElementById('program-medicine-finish').classList.contains('actived')) {
      trostBridgeConfig.firebaseEvent({
        eventName: 'trost_mentalcare_tab',
        ...firebaseEventKey.trost_checkpage_dependencesurvey_complete
      });
      // 결과 점수 계산
      for (let i = 0; i < questionLength; i++) {
        const questionAnswerEl = questionEl[i].getElementsByTagName('td');
        const questionAnswerLength = questionEl[i].getElementsByTagName('td').length;

        for (let j = 0; j < questionAnswerLength; j++) {
          if (questionAnswerEl[j].classList.contains('clicked')) {
            testPoint += questionAnswerEl[j].getAttribute('data-value') * 1;
          }
        }
      }

      const reqData = {
        type: 'submit',
        clientID: getClientID(),
        testType: 'medicine',
        testResult: {
          user: {},
          report: { point: testPoint }
        }
      };

      requestPOST(`${OLD_API_URL}/test/`, reqData, (status, resData) => {
        if (status) {
          location.href = `/service/test/medicine/report/?id=${resData.data.shareID}`;
        }
      });
    }
  });
});
